


















import Vue, { PropType } from 'vue'
import { debounce } from 'debounce'
import mediaMixin from '@/mixins/media-mixin'
import { MediaFilterParams } from '@/types/FilterParams.interface'
import Media, { MediaFolder } from '@/types/Media.interface'
export default Vue.extend({
    mixins: [mediaMixin],
    props: {
        folder: {
            type: String as PropType<MediaFolder>,
            required: true
        }
    },
    data() {
        return {
            //  Determines if we are showing the filter list or not
            filtered: false,
            //  Our temporary groups list
            filterResults: null,
            //  Our placeholder for our media list
            mediaListPlaceholder: {
                img: 'noDocuments',
                content: 'No Files to Display'
            },
            //  Determines if we are showing the search results list or not
            searched: false,
            //  Our temporary groups list
            searchResults: null,
            //  Our container for our search text
            searchtext: '',
            toolbar: {
                title: `${this.folder.toProperCase()} (Folder)`,
                left: [
                    {
                        title: 'Back',
                        icon: 'mdi-chevron-left',
                        back: '/media',
                        tooltip: 'Back',
                        permission: 0
                    }
                ]
            }
        }
    },
    computed: {
        defaultParams(): string {
            //  Our getter is the selector + DefaultParams
            const getter = this.selector + 'DefaultParams'

            //  Return our getter from the store
            return this.$store.getters[getter]
        },
        folderMedia(): Media[] {
            //  Return based on selector
            return this.$store.getters[this.selector]
        },
        media(): Media[] {
            //  If we have filtered, then display our filtered list
            if (this.filtered) return this.filterResults
            //  If we are searching then display our temporary list
            else if (this.searched) return this.searchResults
            //  Return our media based on the selector
            return this.folderMedia
        },
        mediaParams: {
            get(): MediaFilterParams {
                //  Our getter is our selector + Params
                const getter = this.selector + 'Params'

                //  Return params based on selector
                return this.$store.getters[getter]
            },
            set(val: MediaFilterParams): void {
                //  Our mutation is our selector + ParamsSet
                const mutation = this.selector + 'ParamsSet'

                //  Commit the mutation
                this.$store.commit(mutation, val)
            }
        },
        search: {
            get(): string {
                return this.searchtext
            },
            set: debounce(function (val: string): void {
                //  Set the searchtext state
                this.searchtext = val
                this.mediaSearch()
            }, 750)
        },
        selector(): string {
            //  Convert folder name to proper case
            const folderName = this.folder.toProperCase()

            //  Create our selector
            const selector = `mediaViewMedia${folderName}`

            //  Return our selector
            return selector
        }
    },
    methods: {
        //  Applies our filter to our current list of media
        applyFilter(params: MediaFilterParams): Media[] {
            // Grab our current list of media
            const medias = this.folderMedia

            //  Grab the value from our params
            const val = params.value

            //  Grab the key from our params
            const key = params.key

            //  If we are using a sort key, then just sort and return
            if (key === 'sort') return this.applySort(val)

            //  Else, get our filter from the params
            const filter = {
                images: (m: Media) => m.type.includes('image'),
                pdfs: (m: Media) => m.type.includes('pdf')
            }

            //  Apply our filter
            const filtered = medias.filter((x: Media) => filter[val](x))

            //  Return our filtered list
            return filtered
        },
        //  Applies a sorting to our array of media without mutating
        applySort(sort: string): Media[] {
            //  Create our sorting map
            const sorter = {
                asc: (x: Media, y: Media) =>
                    +window.getDate(x.updated_at) - +window.getDate(y.updated_at),
                desc: (x: Media, y: Media) =>
                    +window.getDate(y.updated_at) - +window.getDate(x.updated_at),
                large: (x: Media, y: Media) => y.size - x.size,
                small: (x: Media, y: Media) => x.size - y.size
            }

            //  Clone our media
            const medias = window._.cloneDeep(this.folderMedia)

            //  Sort this media and return
            return medias.sort((x: Media, y: Media) => sorter[sort](x, y))
        },
        //  Search inline on our media to see if any have query in name
        mediaSearch(): void {
            //  If search text is null then reset
            if (!this.searchtext) {
                //  Set to false so we display regular list
                this.searched = false
                //  Set to null to get rid of our previous list of media
                return (this.searchResults = null)
            }

            //  Else, hit up the API to search
            const text = this.searchtext

            //  Grab our media
            const media = this.folderMedia

            //  Get our search results
            const results = media.search(text, ['name'])

            //  Set our search results
            this.searchResults = results || []

            //  Regardless of result, we searched so display the list
            this.searched = true
        },
        //  Occurs when the filter is applied
        onFilterChanged(params: MediaFilterParams): void {
            //  Check if the applied filter is the same as current filter
            const isSame = window._.isEqual(this.mediaParams, params)

            //  If the filter is the same then do nothing
            if (isSame) return

            //  Else, update our store params
            this.mediaParams = params

            //  Check if the applied filter is the default
            const isDefault = window._.isEqual(this.defaultParams, params)

            //  If it is default, then clear our filtered and list
            if (isDefault) {
                this.filtered = false
                this.filterResults = null
                return
            }

            //  We don't paginate media so we just need to filter our actual list
            const filtered = this.applyFilter(params)

            //  Set our temporary list
            this.filterResults = filtered

            //  Set filtered to true to display our new list
            this.filtered = true
        }
    }
})
